import { atom, DefaultValue, selector } from "recoil"
import { shoppableVideosSelector } from "../../selectors/shoppable-videos-selector"
import { someHaveOnDeviceSelector } from "../../selectors/some-have-on-selectors"
import { shoppableMNPVideoAtom } from "../../atoms/shoppableVideos"

const watchPartyScreenAtom = atom({
  key: "watchPartyScreenAtom",
  default: false
})

export const watchPartyLoopStatusAtom = atom({
  key: "watchPartyLoopStatusAtom",
  default: true
})

export const watchPartyScreenSelector = selector<boolean>({
  key: "watchPartyScreenSelector",
  get: ({ get }) => {
    const isMNPShoppable =
      get(shoppableVideosSelector) &&
      !get(someHaveOnDeviceSelector) &&
      get(shoppableMNPVideoAtom).enabledShoppableMNP &&
      get(shoppableMNPVideoAtom).typeShoppableMNP === "play"
    return get(watchPartyScreenAtom) || isMNPShoppable
  },
  set: ({ set }, watchPartyScreen) => {
    set(watchPartyScreenAtom, watchPartyScreen)
  }
})

const watchPartyScreenLinkAtom = atom({
  key: "watchPartyScreenLinkAtom",
  default: ""
})

export const watchPartyScreenLinkSelector = selector<string>({
  key: "watchPartyScreenLinkSelector",
  get: ({ get }) => {
    return get(watchPartyScreenLinkAtom)
  },
  set: ({ set }, watchPartyScreenLink) => {
    set(watchPartyScreenLinkAtom, watchPartyScreenLink)
  }
})

export const watchPartyHostIdAtom = atom({
  key: "watchPartyHostIdAtom",
  default: ""
})

export const watchPartyHideControlsAtom = atom<boolean>({
  key: "watchPartyHideControlsAtom",
  default: true
})

export const watchPartyHideControlsSelector = selector<boolean>({
  key: "watchPartyHideControlsSelector",
  get: ({ get }) => {
    return (
      get(watchPartyHostIdAtom) !== "modNotPresentVideo" &&
      get(watchPartyHostIdAtom) !== "modNotPresentImage" &&
      get(watchPartyHostIdAtom) !== "modNotPresentOverlay" &&
      get(watchPartyHideControlsAtom)
    )
  }
})

export const watchPartyHostIdSelector = selector<string>({
  key: "watchPartyHostIdSelector",
  get: ({ get }) => {
    return get(watchPartyHostIdAtom)
  },
  set: ({ set }, watchPartyHostId) => {
    set(watchPartyHostIdAtom, watchPartyHostId)
  }
})

export const watchPartyCallbackSelector = selector({
  key: "watchPartyCallbackSelector",
  get: ({ getCallback, get }) => {
    const getWatchPartyHostId = getCallback(({ snapshot }) => async () => {
      const data = await snapshot.getPromise(watchPartyHostIdSelector)
      return data
    })
    return { getWatchPartyHostId }
  }
})

export const setWatchPartySelector = selector<{
  hostId?: string
  link: string
  enabled: boolean
}>({
  key: "setWatchPartySelector",
  get: ({ get }) => {
    return {
      hostId: get(watchPartyHostIdAtom),
      link: get(watchPartyScreenLinkAtom),
      enabled: get(watchPartyScreenAtom)
    }
  },
  set: ({ set }, action) => {
    if (action instanceof DefaultValue) {
      return
    }
    const { enabled, hostId, link } = action

    hostId && set(watchPartyHostIdAtom, hostId)
    set(watchPartyScreenLinkAtom, link)
    set(watchPartyScreenAtom, enabled)
  }
})
